import './Footer.css';

export default function Footer() {
  return (
    <footer className="footer">
      <div className="container footer__inner">
        <div className="footer__brand">
          <span className="footer__logo">MECAPISCO <span>S.A.C.</span></span>
          <p className="footer__tagline">
            Transportamos más que carga,<br />transportamos confianza.
          </p>
        </div>
        <div className="footer__links">
          <a href="#inicio">Inicio</a>
          <a href="#nosotros">Nosotros</a>
          <a href="#servicios">Servicios</a>
          <a href="#clientes">Clientes</a>
          <a href="#contacto">Contacto</a>
        </div>
        <div className="footer__contact">
          <a href="tel:988978485">📞 988 978 485</a>
          <a href="mailto:jbarbaran@mecapisco.com.pe">✉️ jbarbaran@mecapisco.com.pe</a>
          <span>📍 Pisco – Ica – Perú</span>
        </div>
      </div>
      <div className="footer__bottom">
        <div className="container">
          © {new Date().getFullYear()} MECAPISCO S.A.C. Todos los derechos reservados.
        </div>
      </div>
    </footer>
  );
}
